var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8931 8.27263L31.7663 15.1373C31.7482 16.0792 32.346 17.329 33.1067 17.8905L37.5986 21.2956C40.4785 23.4692 40.0076 26.1317 36.5662 27.2185L30.7158 29.0479C29.7377 29.3558 28.7053 30.4244 28.4517 31.4206L27.057 36.7458C25.9522 40.9479 23.199 41.3645 20.9168 37.6695L17.729 32.5074C17.1494 31.5655 15.7728 30.8591 14.686 30.9135L8.63647 31.2214C4.30755 31.4387 3.07587 28.9392 5.90144 25.6427L9.48772 21.4768C10.1579 20.6979 10.4658 19.2489 10.1579 18.2708L8.32859 12.4204C7.25994 8.97901 9.17986 7.0772 12.6032 8.20019L17.9464 9.95712C18.852 10.2469 20.2105 10.0477 20.9712 9.48618L26.5499 5.46516C29.5566 3.29164 31.9655 4.55953 31.8931 8.27263Z",
    fill: "#F6C003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M39.41 37.8523L33.9218 32.3642C33.3965 31.8389 32.5271 31.8389 32.0019 32.3642C31.4766 32.8894 31.4766 33.7588 32.0019 34.2841L37.4901 39.7722C37.7617 40.0439 38.1058 40.1707 38.45 40.1707C38.7941 40.1707 39.1383 40.0439 39.41 39.7722C39.9353 39.247 39.9353 38.3776 39.41 37.8523Z",
    fill: "#0FC100"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/Star.e680dbfeb6ceb8dbc41e5027649ba57f.svg";
export { ForwardRef as ReactComponent };